import { Formik, useField } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import Question from "components/shared/ReportComponents/Questions/Question";
import QuestionWithTemplate from "./QuestionWithTemplate";
import { memo, useMemo } from "react";

const RenderQuestion = memo(function RenderQuestion({ question, preview, ...props }) {
  const [field] = useField(props.fieldName);
  return (
    <>
      <div className="d-flex align-itmes-center gap-10 mb-2">
        {question?.visibility !== "default" && (
          <AppInputField
            name={`${question?.id}.other_details.visibility`}
            type="checkbox"
            className="form-check"
            style={{ height: 25, width: 25 }}
          />
        )}
        {props.showQuestion !== false && (
          <h6 className="m-0 fw-sbold themeBlue pb-1">{question?.question}</h6>
        )}
      </div>
      {question?.question_type === "textarea" ? (
        <Question
          question={question}
          {...props}
          {...field}
        />
      ) : question?.question_type === "template" ? (
        <QuestionWithTemplate preview={preview} question={question} {...props} {...field} />
      ) : (
        <p>Unable to render question</p>
      )}
    </>
  );
});


export const RenderQuestionById = memo(function RenderQuestionById({ questionId, reportQuestions, ...props }) {
  const question = useMemo(() => {
    if (!questionId || !reportQuestions?.length) {
      return null;
    }

    return reportQuestions?.find((q) => q.id === questionId);
  }, []);
  if (!question) {
    return <p>Question not found!</p>;
  }

  return (
    <RenderQuestion
      question={question}
      fieldName={question?.id}
      {...props}
    />
  );
})

export default RenderQuestion;